module.exports = __webpack_public_path__ + "img/happy-cute-smiling.91b4e49a.png";